"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:7.4.0'] && _();
}
catch (e) { }
